import { useEffect, useState } from "react";
import { RESTAURANTS } from "@/data/restaurants";

const API = process.env.REACT_APP_BACKEND_URL;

export default function StatsPanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/stats`)
      .then((r) => r.json())
      .then(setData)
      .catch(() => setError(true));
  }, []);

  const nameOf = (id) =>
    (RESTAURANTS.find((r) => r.id === id) || {}).name || id;

  return (
    <div className="min-h-screen bg-ink px-5 py-16 text-bone" data-testid="stats-panel">
      <div className="mx-auto max-w-3xl">
        <p className="text-xs uppercase tracking-[0.3em] text-gold/90">
          Statistiques · usage interne
        </p>
        <h1 className="font-display mt-4 text-4xl md:text-5xl">
          Visites du site
        </h1>

        {error && (
          <p className="mt-10 text-zinc-400" data-testid="stats-error">
            Impossible de charger les statistiques.
          </p>
        )}

        {!error && !data && (
          <p className="mt-10 text-zinc-400">Chargement…</p>
        )}

        {!error && data && (
          <>
            <div
              className="mt-10 border border-gold/30 bg-coal p-10 text-center"
              data-testid="stats-visits"
            >
              <p className="text-xs uppercase tracking-[0.25em] text-zinc-400">
                Visites uniques par session
              </p>
              <p className="font-display mt-3 text-7xl text-gold">
                {data.visits}
              </p>
            </div>

            <h2 className="font-display mt-14 text-3xl">
              Clics par établissement
            </h2>
            <div
              className="mt-6 divide-y divide-white/10 border border-white/10 bg-coal"
              data-testid="stats-clicks"
            >
              {data.clicks.length === 0 && (
                <p className="p-6 text-sm text-zinc-400">
                  Aucun clic enregistré pour le moment.
                </p>
              )}
              {data.clicks
                .sort((a, b) => b.count - a.count)
                .map((c) => (
                  <div
                    key={c.id}
                    className="flex items-center justify-between gap-4 p-5"
                    data-testid={`stats-click-${c.id}`}
                  >
                    <span className="font-display text-lg">{nameOf(c.id)}</span>
                    <span className="font-display text-2xl text-gold">
                      {c.count}
                    </span>
                  </div>
                ))}
            </div>

            <p className="mt-10 text-xs text-zinc-600">
              Page privée : ajoutez #stats à la fin de l'adresse du site pour
              revenir ici.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
